import React from "react";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

function Loading({visible, light = false}) {
	return (
		visible && (
			<Backdrop
				sx={{
					zIndex: (theme) => theme.zIndex.drawer + 1,
					backgroundColor: light
						? "rgba(255, 255, 255, 0.8)"
						: "rgba(0, 0, 0, 0.5)",
				}}
				open
			>
				<CircularProgress color={light ? "primary" : "inherit"} />
			</Backdrop>
		)
	);
}

export default Loading;
